module.exports = __webpack_public_path__ + "img/circle-envelope.20e9655c.svg";